// extracted by mini-css-extract-plugin
export default {"container":"submission-reason_container__hIeOb"};